import React, {useEffect, useState, useRef} from 'react';
import {Card, Container, Row, Col, Collapse, Form, Tab, Nav, Table, Button, Modal} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {FaChevronDown, FaChevronUp} from 'react-icons/fa';
import {fetchGetData, fetchPostData} from "./api";
import {AgGridReact} from 'ag-grid-react';
import {ClientSideRowModelModule} from 'ag-grid-community';
import {ValidationModule} from 'ag-grid-community';
import {ModuleRegistry} from 'ag-grid-community';
import {PaginationModule} from 'ag-grid-community';
import {CsvExportModule} from 'ag-grid-community';
import { ClientSideRowModelApiModule } from 'ag-grid-community';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import * as XLSX from 'xlsx';
ModuleRegistry.registerModules([PaginationModule, CsvExportModule, ClientSideRowModelApiModule]);

const TrackEmployee = () => {
    const [companyName, setCompanyName] = useState('');
    const [jobEmployer, setEmployer] = useState([]);
    const [vacancyName, setVacancyName] = useState('');
    const [jobVacancy, setVacancy] = useState([]);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [lastClickedRowId, setLastClickedRowId] = useState(null);
    const [district, setDistrict] = useState("");
    const [districtList, setDistrictList] = useState([
        {
            "id": "அரியலூர்",
            "title": "அரியலூர்"
        },
        {
            "id": "சென்னை",
            "title": "சென்னை"
        },
        {
            "id": "கோயம்புத்தூர்",
            "title": "கோயம்புத்தூர்"
        },
        {
            "id": "கடலூர்",
            "title": "கடலூர்"
        },
        {
            "id": "தர்மபுரி",
            "title": "தர்மபுரி"
        },
        {
            "id": "திண்டுக்கல்",
            "title": "திண்டுக்கல்"
        },
        {
            "id": "ஈரோடு",
            "title": "ஈரோடு"
        },
        {
            "id": "காஞ்சிபுரம்",
            "title": "காஞ்சிபுரம்"
        },
        {
            "id": "கன்னியாகுமரி",
            "title": "கன்னியாகுமரி"
        },
        {
            "id": "கரூர்",
            "title": "கரூர்"
        },
        {
            "id": "கிருஷ்ணகிரி",
            "title": "கிருஷ்ணகிரி"
        },
        {
            "id": "மதுரை",
            "title": "மதுரை"
        },
        {
            "id": "நாகப்பட்டினம்",
            "title": "நாகப்பட்டினம்"
        },
        {
            "id": "நாமக்கல்",
            "title": "நாமக்கல்"
        },
        {
            "id": "பெரம்பலூர்",
            "title": "பெரம்பலூர்"
        },
        {
            "id": "புதுக்கோட்டை",
            "title": "புதுக்கோட்டை"
        },
        {
            "id": "இராமநாதபுரம்",
            "title": "இராமநாதபுரம்"
        },
        {
            "id": "சேலம்",
            "title": "சேலம்"
        },
        {
            "id": "சிவகங்கை",
            "title": "சிவகங்கை"
        },
        {
            "id": "தஞ்சாவூர்",
            "title": "தஞ்சாவூர்"
        },
        {
            "id": "நீலகிரி",
            "title": "நீலகிரி"
        },
        {
            "id": "தேனி",
            "title": "தேனி"
        },
        {
            "id": "திருவள்ளூர்",
            "title": "திருவள்ளூர்"
        },
        {
            "id": "திருவண்ணாமலை",
            "title": "திருவண்ணாமலை"
        },
        {
            "id": "திருவாரூர்",
            "title": "திருவாரூர்"
        },
        {
            "id": "தூத்துக்குடி",
            "title": "தூத்துக்குடி"
        },
        {
            "id": "திருச்சிராப்பள்ளி",
            "title": "திருச்சிராப்பள்ளி"
        },
        {
            "id": "திருநெல்வேலி",
            "title": "திருநெல்வேலி"
        },
        {
            "id": "திருப்பூர்",
            "title": "திருப்பூர்"
        },
        {
            "id": "வேலூர்",
            "title": "வேலூர்"
        },
        {
            "id": "விழுப்புரம்",
            "title": "விழுப்புரம்"
        },
        {
            "id": "விருதுநகர்",
            "title": "விருதுநகர்"
        },
        {
            "id": "புதுச்சேரி",
            "title": "புதுச்சேரி"
        },
        {
            "id": "தென்காசி",
            "title": "தென்காசி"
        },
        {
            "id": "கள்ளக்குறிச்சி",
            "title": "கள்ளக்குறிச்சி"
        },
        {
            "id": "திருப்பத்தூர்",
            "title": "திருப்பத்தூர்"
        },
        {
            "id": "ராணிப்பேட்டை",
            "title": "ராணிப்பேட்டை"
        },
        {
            "id": "செங்கல்பட்டு",
            "title": "செங்கல்பட்டு"
        },
        {
            "id": "மயிலாடுதுறை",
            "title": "மயிலாடுதுறை"
        }
    ]);
    const [user, setUserData] = useState({
        name: "John Doe",
        email: "john.doe@example.com",
        phone: "+1234567890",
    });

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const columnsStaffing = [
        {headerName: "S. No", valueGetter: (params) => params.node.rowIndex + 1, width: 80},
        // {
        //     headerName: 'Actions',
        //     field: 'actions',
        //     // cellRenderer: (params) => (
        //     //     <div>
        //     //         {/*<Button className="mb-3" variant="warning" onClick={() => handleEdit(params.data)}>Edit</Button>&nbsp;*/}
        //     //         {/*<Button className="mb-3" variant="danger" onClick={() => handleDelete(params.data)}>Delete</Button>*/}
        //     //         <Button className="mb-3" variant="warning"
        //     //                 onClick={() => handleView(params.data)}>View</Button>&nbsp;
        //     //     </div>
        //     // ),
        //     cellRenderer: (params) => (
        //         <div>
        //             <Button
        //                 className={`mb-3 ${params.data._id === lastClickedRowId ? "highlighted-button" : ""}`}
        //                 variant="primary" // Default color
        //                 onClick={() => {
        //                     setLastClickedRowId(params.data._id);// Track last clicked row
        //                     handleView(params.data, params.node.rowIndex); // Handle click
        //                 }}
        //             >
        //                 View
        //             </Button>
        //         </div>
        //     ),
        // },
        {headerName: "Name", field: "name"},
        {headerName: "Mobile", field: "mobile"},
        {headerName: "Whatsapp", field: "from"},
        {headerName: "Gender", field: "gender"},
        {headerName: "Age", field: "age"},
        {headerName: "Qualification", field: "qualification"},
        {headerName: "Experience", field: "experience"},
        {headerName: "District", field: "district"},
        {headerName: "Work location", field: "work_location"},
        {headerName: "Job field", field: "job_field"},
        {headerName: "Experience field", field: "experience_field"},
        {headerName: "Joining time", field: "joining_time"},
        {headerName: "Created on", field: "createdAt"},
    ];

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // const [districtRes, jobEmployer] = await Promise.all([
                //     fetchGetData('/employer/get/employees/interest', { id: '676038c7ce995fb0ad12c64e' }), // Replace with actual API
                //     fetchGetData('/master/get/employer/new')
                // ]);
                // setExcelData(districtRes.data);
                // setEmployer(jobEmployer.data);
                const [employeeLeads] = await Promise.all([
                    fetchPostData('/employee/get/leads')
                ]);
                setExcelData(employeeLeads.data);
                const [jobEmployer] = await Promise.all([
                    fetchGetData('/master/get/employer/new')
                ]);
                setEmployer(jobEmployer.data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setEmployer([]);
            }
        };

        fetchInitialData();
    }, []);
    const fetchData = async (selectedEmployerId) => {
        try {
            const [jobVacancy] = await Promise.all([
                fetchGetData('/employer/get/employer/vacancy', {id: selectedEmployerId})
            ]);
            setVacancy(jobVacancy.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleSelectEmployerChange = (e) => {
        const selectedEmployerId = e.target.value;
        setCompanyName(selectedEmployerId)
        setExcelData([]);
        if (selectedEmployerId) {
            fetchData(selectedEmployerId); // Fetch data based on selected employer
        } else {
            setVacancy([]);
        }
    };
    const handleSelectVacanyChange = async (e) => {
        setExcelData([]);
        setLoading(true)
        const selectedVacancyId = e.target.value;
        setVacancyName(selectedVacancyId)
        setLastClickedRowId(null)
        if (selectedVacancyId) {
            try {
                const [jobVacancy] = await Promise.all([
                    fetchGetData('/employer/get/employees/interest', {id: selectedVacancyId})
                ]);
                setExcelData(jobVacancy.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false)
            }
        } else {
            setExcelData([]);
            setLoading(false)
        }
    };

    const gridRef = useRef(null);

    const handleDownload = () => {
        const selectedEmployer = jobEmployer.find(role => role.id.toString() === companyName)?.english;
        const selectedVacancy = jobVacancy.find(role => role._id.toString() === vacancyName)?.jobtitle;
        const optionsCSV = {
            // fileName: 'my-data-' + new Date().toISOString() + '.csv',
            fileName: 'employee_leads_' + new Date().toLocaleTimeString() + '.csv',
        };
        // gridRef.current.api.exportDataAsCsv(optionsCSV);
        let rowData = [];
        gridRef.current.api.forEachNodeAfterFilter(node => rowData.push(node.data));
        var filename = 'employee_leads_' + new Date().toLocaleTimeString() + '.xlsx';
        var data = rowData;
        var ws = XLSX.utils.json_to_sheet(data);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, filename);
    };
    useEffect(() => {
        if (district) {
            handleDateSelect([startDate, endDate]);
        }
    }, [district]);
    const handleDateSelect = async (date) => {
        console.log("Selected Date Range:", date); // This will log the selected range
        const getStartDate = date[0] ? date[0].toLocaleDateString() : null
        const getEndDate = date[1] ? date[1].toLocaleDateString() : null
        if ((getStartDate && getEndDate) || (!getStartDate && !getEndDate) || district) {
            console.log("Start Date:", moment(getStartDate).format("YYYY-MM-DD"));
            console.log("End Date:", moment(getEndDate).format("YYYY-MM-DD"));
            const [employeeLeads] = await Promise.all([
                fetchPostData('/employee/get/leads', {
                    startDate: moment(getStartDate).isValid() ? moment(getStartDate).format("YYYY-MM-DD 00:00:00") : null,
                    endDate: moment(getEndDate).isValid() ? moment(getEndDate).format("YYYY-MM-DD 23:59:59") : null,
                    district: district ? district : null,
                }, {
                    'Content-Type': 'application/json',
                })
            ]);
            setExcelData(employeeLeads.data);
        }
    };
    return (
        <Container className="mt-5">
            <Row>
                {/* Column 1: Checkboxes (col-3) */}
                <Col md={3}>
                    {/* Collapsible Section 1 */}
                    <Card className="mb-3">
                        <Button className="mb-3" variant="primary">Employee leads</Button>
                        <Form.Group controlId="companyName" className="p-1">
                            <Form.Label>Choose date</Form.Label>
                            <DatePicker
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => {
                                    setDateRange(update);
                                    handleDateSelect(update); // Pass the updated date range
                                }}
                                dateFormat="yyyy-MM-dd"
                                isClearable={true}
                                placeholderText="Select a date range"
                            />
                            {startDate && endDate && (
                                <p>Selected: {startDate.toLocaleDateString()} - {endDate.toLocaleDateString()}</p>
                            )}
                        </Form.Group>
                        <Form.Group controlId="vacancyName" className="p-1">
                            <Form.Label>Choose district</Form.Label>
                            <Form.Select
                                value={district}
                                onChange={(e) => { setDistrict(e.target.value) }}
                                required
                            >
                                <option value="">Choose district</option>
                                {districtList.map(role => (
                                    <option key={role.id} value={role.id}>
                                        {role.title|| 'no district found'} {[role.count] || "5"}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        {/*<Card.Header onClick={() => setOpen1(!open1)} style={{cursor: 'pointer'}}>*/}
                        {/*    Filter Employees 1 <span className="float-end">{open1 ? <FaChevronUp/> :*/}
                        {/*    <FaChevronDown/>}</span>*/}
                        {/*</Card.Header>*/}
                        {/*<Collapse in={open1}>*/}
                        {/*    <div>*/}
                        {/*        <Card.Body>*/}
                        {/*            <Form>*/}
                        {/*                <Form.Check type="checkbox" label="Department A"/>*/}
                        {/*                <Form.Check type="checkbox" label="Department B"/>*/}
                        {/*                <Form.Check type="checkbox" label="Department C"/>*/}
                        {/*            </Form>*/}
                        {/*        </Card.Body>*/}
                        {/*    </div>*/}
                        {/*</Collapse>*/}
                    </Card>

                    {/* Collapsible Section 2 */}
                    {/*<Card className="mb-3">*/}
                    {/*    <Card.Header onClick={() => setOpen2(!open2)} style={{cursor: 'pointer'}}>*/}
                    {/*        Filter Employees 2 <span className="float-end">{open2 ? <FaChevronUp/> :*/}
                    {/*        <FaChevronDown/>}</span>*/}
                    {/*    </Card.Header>*/}
                    {/*    <Collapse in={open2}>*/}
                    {/*        <div>*/}
                    {/*            <Card.Body>*/}
                    {/*                <Form>*/}
                    {/*                    <Form.Check type="checkbox" label="Department A"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department B"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department C"/>*/}
                    {/*                </Form>*/}
                    {/*            </Card.Body>*/}
                    {/*        </div>*/}
                    {/*    </Collapse>*/}
                    {/*</Card>*/}

                    {/* Collapsible Section 3 */}
                    {/*<Card className="mb-3">*/}
                    {/*    <Card.Header onClick={() => setOpen3(!open3)} style={{cursor: 'pointer'}}>*/}
                    {/*        Filter Employees 3 <span className="float-end">{open3 ? <FaChevronUp/> :*/}
                    {/*        <FaChevronDown/>}</span>*/}
                    {/*    </Card.Header>*/}
                    {/*    <Collapse in={open3}>*/}
                    {/*        <div>*/}
                    {/*            <Card.Body>*/}
                    {/*                <Form>*/}
                    {/*                    <Form.Check type="checkbox" label="Department A"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department B"/>*/}
                    {/*                    <Form.Check type="checkbox" label="Department C"/>*/}
                    {/*                </Form>*/}
                    {/*            </Card.Body>*/}
                    {/*        </div>*/}
                    {/*    </Collapse>*/}
                    {/*</Card>*/}
                </Col>

                {/* Column 2: Tabs and Table (col-9) */}
                <Col md={9}>
                    <Tab.Container defaultActiveKey="tab2">
                        <Card>
                            <Card.Body>
                                {excelData.length > 0 && (
                                    <Button className="mb-3" variant="primary" onClick={handleDownload}>
                                        Download CSV
                                    </Button>
                                )}
                                <div className="ag-theme-alpine" style={{height: 400, width: '100%'}}>
                                    <style>
                                        {`
          .highlighted-button {
            background-color: #f0ad4e !important; /* Custom highlight color (e.g., orange) */
            border-color: #eea236;
          }
        `}
                                    </style>
                                    <AgGridReact
                                        ref={gridRef}
                                        columnDefs={columnsStaffing}
                                        rowData={excelData}
                                        pagination={true}
                                        domLayout="autoHeight"
                                        modules={[ClientSideRowModelModule]}
                                        modules={[ValidationModule, ClientSideRowModelModule]}
                                        loading={loading}
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </Tab.Container>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{user.user_name ? decodeURIComponent(user.user_name.replace(/\+/g, ' ')) : 'No Name Available'} - {user.mobile}</Modal.Title>
                </Modal.Header>
                {/*<Modal.Body>*/}
                {/*    This is the content of the modal.*/}
                {/*</Modal.Body>*/}
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-4">
                            <strong>ID:</strong>
                        </div>
                        <div className="col-md-8">{user.user_id}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <strong>Name:</strong>
                        </div>
                        <div
                            className="col-md-8">{user.user_name ? decodeURIComponent(user.user_name.replace(/\+/g, ' ')) : 'No Name Available'}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Mobile:</strong>
                        </div>
                        <div className="col-md-8">{user.mobile}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Location:</strong>
                        </div>
                        <div className="col-md-8">{user.location}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Job titles:</strong>
                        </div>
                        <div className="col-md-8">{user.preferred_jobs}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Qualification:</strong>
                        </div>
                        <div className="col-md-8">{user.qualification}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Last Logged In:</strong>
                        </div>
                        <div className="col-md-8">{user.last_login}</div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <strong>Interest received at:</strong>
                        </div>
                        <div className="col-md-8">{user.responseGetAt}</div>
                    </div>
                </Modal.Body>
            </Modal>
        </Container>
    )
        ;
};

export default TrackEmployee;
